'use strict';

module.exports = {
    LANG: 'id-id',
    SIGN: 'Masuk',
    REGISTER: 'Daftar',
    QUICK_ACCESS: 'akses cepat dengan',
    SIGN_JOIN: 'Masuk atau gabung gratis!',
    NOT_MEMBER: 'Masih bukan member?',
    ALREADY_MEMBER: 'Sudah punya akun AliExpress/Alibaba?',
    SHOW_ALL: 'Tampilkan semua',
    HIDE: 'Sembunyikan'
};